import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePicker from "react-multi-date-picker";
import { secretKey } from "./data";
import "./app.css";

const MySwal = withReactContent(Swal2);

const AddHolidayPopUp = (props) => {
  const [dateFrom, setDateFrom] = useState(
    props.mode === "edit" ? props.holiday.date_from : ""
  );
  const [dateTo, setDateTo] = useState(
    props.mode === "edit" ? props.holiday.date_to : ""
  );
  const [user, setUser] = useState(
    props.mode === "edit"
      ? props.holiday.user
      : props.user.role === "user" || props.user.role === "userplus"
      ? props.user.name
      : ""
  );

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value);
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value);
  };

  const handleUserChange = (e) => {
    setUser(e.target.value);
  };

  const checkBlock = () => {
    var blocks = props.holidaysBlockData;
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (el.date_from >= dateFrom && el.date_from <= dateTo) ||
          (dateFrom >= el.date_from && dateFrom <= el.date_to)
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const checkUserTeam = (user) => {
    var user = props.users.filter((el) => el.name === user)[0];
    var bool = false;
    if (+user.urlop_zespol === +props.team) {
      bool = true;
    }
    return bool;
  };

  const checkOthersHolidays = () => {
    var blocks = props.holidaysData.filter((el) => checkUserTeam(el.user));
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      var count = [];
      blocks.map((el) => {
        if (
          (el.date_from >= dateFrom &&
            el.date_from <= dateTo &&
            el.type === "holiday") ||
          (dateFrom >= el.date_from &&
            dateFrom <= el.date_to &&
            el.type === "holiday")
        ) {
          count.push(el);
        }
      });
    }
    if (count.length >= 2) {
      bool = true;
    }

    return bool;
  };

  const checkSameHolidays = () => {
    var blocks = props.holidaysData;
    if (props.type === "Kara") {
      blocks = blocks.filter((el) => el.type === "Kara");
    } else {
      blocks = blocks.filter((el) => el.type === "Urlop");
    }
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      var count = [];
      blocks.map((el) => {
        if (
          ((el.date_from >= dateFrom && el.date_from <= dateTo) ||
            (dateFrom >= el.date_from && dateFrom <= el.date_to)) &&
          user === el.user &&
          el.type === props.type
        ) {
          count.push(el);
        }
      });
    }
    if (count.length > 0) {
      bool = true;
    }

    return bool;
  };

  const checkSameHolidaysEdit = (id) => {
    var blocks = props.holidaysData;
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      var count = [];
      blocks.map((el) => {
        if (
          ((el.date_from >= dateFrom && el.date_from <= dateTo) ||
            (dateFrom >= el.date_from && dateFrom <= el.date_to)) &&
          props.holiday.user === el.user &&
          el.id !== id &&
          el.type === props.type
        ) {
          count.push(el);
          console.log(el);
        }
      });
    }
    if (count.length > 0) {
      bool = true;
    }

    return bool;
  };

  const validateHoliday = () => {
    if (
      dateFrom.length > 0 &&
      dateTo.length > 0 &&
      new Date(dateTo) >= new Date(dateFrom)
    ) {
      return true;
    }

    return false;
  };

  const editHoliday = async (e) => {
    if (validateHoliday()) {
      if (checkSameHolidaysEdit(props.holiday.id)) {
        MySwal.fire({
          icon: "error",
          title: "Istnieje",
          text: `już ${
            props.type === "Kara" ? "kara" : "urlop"
          }, w tym samym zakresie dat`,
        });
      } else {
        var body = {
          date_from: dateFrom,
          date_to: dateTo,
          user: user,
          id: props.holiday.id,
        };

        await fetch("https://apisplit.ftpeople.pl/editHoliday", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        MySwal.fire({
          icon: "success",
          title: "Zmieniono",
          text: props.type === "Kara" ? "karę" : "wniosek urlopowy",
        }).then((result) => {
          props.close();
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const addHoliday = async (e) => {
    if (validateHoliday()) {
      if (checkSameHolidays()) {
        MySwal.fire({
          icon: "error",
          title: "Istnieje",
          text: `już ${
            props.type === "Kara" ? "kara" : "urlop"
          }, w tym samym zakresie dat`,
        });
      } else {
        var body = {
          date_from: dateFrom,
          date_to: dateTo,
          user: user,
          status: "ACCEPTED",
          date_added: new Date(),
          date_accepted: new Date(),
          type: props.type,
        };

        await fetch("https://apisplit.ftpeople.pl/addHoliday", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: props.type === "Kara" ? "karę" : "wniosek urlopowy",
        }).then((result) => {
          props.close();
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const deleteHoliday = async (id) => {
    var body = {
      id: props.holiday.id,
    };

    await fetch("https://apisplit.ftpeople.pl/deleteHoliday", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: props.type === "Kara" ? "karę" : "wniosek urlopowy",
    }).then((result) => {
      props.close();
    });
  };

  const addHolidayUser = async (e) => {
    if (validateHoliday()) {
      if (checkSameHolidays()) {
        MySwal.fire({
          icon: "error",
          title: "Istnieje",
          text: `już ${
            props.type === "Kara" ? "kara" : "urlop"
          }, w tym samym zakresie dat`,
        });
      } else {
        var body = {
          date_from: dateFrom,
          date_to: dateTo,
          user: user,
          status: "REPORTED",
          date_added: new Date(),
          date_accepted: "",
          type: props.type,
        };

        await fetch("https://apisplit.ftpeople.pl/addHoliday", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: props.type === "Kara" ? "karę" : "wniosek urlopowy",
        }).then((result) => {
          props.close();
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: "10vh",
          right: "0",
          marginRight: "20px",
          padding: "20px",
          backgroundColor: "white",
          width: "30vw",
          boxShadow: "rgb(66, 68, 90) -8px 0px 24px 0px",
          borderRadius: "15px",
          zIndex: "2",
          overflowY: "scroll",
          paddingBottom: "20px",
        }}
      >
        <div className="closeBox" style={{ paddingBottom: "10px" }}>
          <button
            style={{
              width: "30px",
              textAlign: "center",
              backgroundColor: "red",
              color: "white",
              borderRadius: "5px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={props.close}
          >
            X
          </button>
        </div>

        {props.user.role === "admin" ? (
          <div className="inputBox">
            <div className="inputCol_1" style={{ flexWrap: "wrap" }}>
              <label
                style={{
                  width: "100%",
                  display: "block",
                  marginBottom: "10px",
                  textTransform: "uppercase",
                  fontSize: ".8vw",
                }}
              >
                Pracownik <span className="requiredStar">*</span>
              </label>
              <select
                style={{ width: "100%" }}
                type="date"
                id="name"
                name="name"
                value={user}
                onChange={(e) => setUser(e.target.value)}
              >
                {props.users.map((el) => (
                  <>
                    <option key={el.name} value={el.name}>
                      {el.name}
                    </option>
                  </>
                ))}
              </select>
            </div>
          </div>
        ) : (
          ""
        )}

        <>
          <div className="inputBox">
            <div className="inputCol_1" style={{ flexWrap: "wrap" }}>
              <label
                style={{
                  width: "100%",
                  display: "block",
                  marginBottom: "10px",
                  textTransform: "uppercase",
                  fontSize: ".8vw",
                }}
              >
                Data rozpoczęcia urlopu
                <span className="requiredStar">*</span>
              </label>
              <input
                style={{ width: "100%" }}
                type="date"
                id="name"
                name="name"
                value={dateFrom}
                onChange={handleDateFromChange}
              />
            </div>
          </div>
          <div className="inputBox">
            <div className="inputCol_1" style={{ flexWrap: "wrap" }}>
              <label
                style={{
                  width: "100%",
                  display: "block",
                  marginBottom: "10px",
                  textTransform: "uppercase",
                  fontSize: ".8vw",
                }}
              >
                Data zakończenia urlopu
                <span className="requiredStar">*</span>
              </label>
              <input
                style={{ width: "100%" }}
                type="date"
                id="name"
                name="name"
                value={dateTo}
                onChange={handleDateToChange}
              />
            </div>
          </div>
        </>

        <div className="saveBoxAP" style={{ display: "flex", gap: "10px" }}>
          <button
            style={{
              marginTop: "5vh",
              width: "450%",
              backgroundColor: "black",
              color: "white",
              borderRadius: "5px",
            }}
            className="paymentMenuButton"
            onClick={
              props.mode === "edit"
                ? editHoliday
                : props.user.role === "user" || props.user.role === "userplus"
                ? addHolidayUser
                : addHoliday
            }
          >
            ZAPISZ
          </button>
          {props.mode === "edit" ? (
            <button
              style={{
                marginTop: "5vh",
                width: "450%",
                backgroundColor: "black",
                color: "white",
                borderRadius: "5px",
              }}
              className="paymentMenuButton"
              onClick={deleteHoliday}
            >
              USUŃ
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default AddHolidayPopUp;
